import { graphHooks } from '@tunasong/graph-lib/react'
import { matchAny, matchTypes } from '@tunasong/models'
import type { LayoutComponent } from '@tunasong/plugin-lib'
import { getAcceptedMimeTypes, usePlugin, usePlugins } from '@tunasong/plugin-lib'
import type { Entity } from '@tunasong/schemas'
import { isMedia } from '@tunasong/schemas'
import { DropZone, EntityList, useNavigateToEntity } from '@tunasong/ui-lib'
import { useMemo } from 'react'
import styles from './files.module.css'

export interface FilesViewProps<T extends Entity> extends LayoutComponent<T> {
  /** e.g., {'image/*': ['jpg', 'png']}*/
  accept?: Record<string, string[]>
}

/** Simple files view */
const FilesView = <T extends Entity>(props: FilesViewProps<T>) => {
  const { entity, accept } = props

  const plugins = usePlugins('all')
  const plugin = usePlugin(entity)

  const { entities: children } = graphHooks.useEntityChildren({
    parentId: entity.id,
    filter: matchAny(isMedia, matchTypes(plugin?.allowChildrenTypes)),
    includeSys: false,
  })
  const navigateToEntity = useNavigateToEntity()
  const mimeTypes = useMemo(() => (accept ? accept : getAcceptedMimeTypes(plugins)), [accept, plugins])

  return (
    <DropZone parentId={entity.id} accept={mimeTypes} uploadOnClick showClickZone>
      <EntityList
        className={styles.list}
        size="large"
        entities={children}
        onOpen={navigateToEntity}
        placeholder="Drop new content here, or click/tap to upload"
      />
    </DropZone>
  )
}

export default FilesView
